/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Form
} from 'react-bootstrap';
import './Checkbox.scss';
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APP_COLORS } from "../Constants";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import SparklesIcon from "../../organization/explore/filters/components/assets/SparklesIcon";
import {PreviewBadge} from "./form/FormLabel";

const DivLockRelative = styled.div`
  position: relative;
`;

const DivLockAbsolute = styled.div`
  position: absolute;
  right: 0;
  top: -28px;
`;

const CheckBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
`;

const IconContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

const LockWrapper = styled.div`
    display: flex;
    align-items: center;
    color: ${APP_COLORS['gray-600']};
`;

const CheckBox = (props) => {
    const {
        id,
        label,
        onChange,
        checked,
        size,
        disabled,
        lockIcon,
        innerState = false,
        isPreview = false,
    } = props;

    const [innerCheck, setInnerCheck] = useState(false);

    return (
        <CheckBoxContainer className={innerState ? 'checkBox no-label' : 'checkBox'}>
            <Form.Check
                type={'checkbox'}
                id={`checkbox-${id}`}
                label={label}
                onChange={(e) => {
                    if (innerState) {
                        setInnerCheck(!innerCheck);
                    }
                    onChange(e.target.checked);
                }}
                checked={innerState ? innerCheck : checked}
                size={size}
                disabled={disabled}
            />
            <IconContent>
                {isPreview && (
                    <PreviewBadge style={{ margin: 0 }}>
                        <SparklesIcon size="12px" />
                        <span style={{ marginLeft: 5, textTransform: 'capitalize' }}>Preview</span>
                    </PreviewBadge>
                )}
                {disabled && lockIcon && (
                    <LockWrapper>
                        <FontAwesomeIcon
                            color={APP_COLORS['gray-600']}
                            icon={faLock}
                            style={{ fontSize: 15 }}
                        />
                    </LockWrapper>
                )}
            </IconContent>
        </CheckBoxContainer>
    );
};


CheckBox.propTypes = {
    id: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'small', 'lg', 'large']),
    onChange: PropTypes.func,
    lockIcon: PropTypes.bool,
};

CheckBox.defaultProps = {
    style: {},
    className: '',
    labelStyle: {},
    size: 'sm',
    onChange: e => e,
    checked: false,
    label: '',
    lockIcon: true,
};

export default CheckBox;
